<template>
  <select
    v-model="value"
    class="custom-select"
  >
    <option
      v-for="variation in variationAttributes"
      :key="variation.variationId"
      :value="variation.urlPath"
      :selected="variationId === variation.variationId"
      :class="{'text-gray-500': !variation.hasStock}"
    >
      {{ optionText(variation) }}
    </option>
  </select>
</template>

<script>
export default {
    name: 'VariationDropdownSelection',
    props: {
        variationAttributes: {
            type: Array,
            default: () => []
        },
        variationId: {
            type: Number,
            required: true
        },
        preloadImageLimit: {
            type: Number,
            default: 12
        },
        lang: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            value: this.variationAttributes.find(v => this.variationId === v.variationId).urlPath
        }
    },
    computed: {
        langPrefix () {
            return this.lang === App.defaultLanguage ? '' : ('/' + this.lang)
        }
    },
    watch: {
        value () {
            this.goToVariation(this.value)
        }
    },
    methods: {
        optionText (variation) {
            if (variation.hasStock) {
                return variation.name
            }
            return variation.name + ' - ' + this.$translate('modeherz::SingleItemPageClient.itemPageSoldOut')
        },
        goToVariation (urlPath) {
            window.location = (this.langPrefix + urlPath)
        }
    }
}
</script>

<style scoped>

</style>
